export default __webpack_public_path__ + "static/media/down-icon.9d16148d.svg";